export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="bg-background-100 border border-background-300/40 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              爆料投稿
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-lg">
              如果你掌握一手黑料或独家爆料线索，欢迎通过以下方式联系我们。
              暗网吃瓜保护投稿人隐私，所有爆料均采用匿名处理，
              绝不透露信息来源。你的每一次爆料，都可能成为全网热议的焦点。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="mailto:tips@anwangchigua.example.com"
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-medium transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-mail-line"></i>
              邮件爆料
            </a>
            <a
              href="#faq"
              className="px-6 py-3 border border-background-300/50 hover:border-accent-500/50 text-foreground-600 hover:text-accent-400 rounded-lg transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-question-line"></i>
              投稿指南
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}